<template>
    <div class="order tableStyle">
        <el-form :inline="true" class="demo-form-inline" size="small">
            <el-form-item label="订单号：" class="screen">
                <el-input v-model="queryForm.query_columns.order_no" placeholder="请输入订单号" clearable @change="getTableList('query')"></el-input>
            </el-form-item>
            <el-form-item label="桩群名称：" class="screen">
                <el-select v-model="queryForm.query_columns.pg_id" placeholder="请选择" filterable clearable @change="getTableList('query')">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in allStation" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="电桩编号：" class="screen">
                <el-input v-model="queryForm.query_columns.pile_code" placeholder="请输入电桩编号" clearable @change="getTableList('query')"></el-input>
            </el-form-item>
            <!-- <el-form-item label="所属厂商：">
                <el-select v-model="queryForm.query_columns.company_id" placeholder="请选择" clearable filterable @change="getTableList('query')">
                    <el-option label="全部" value=""></el-option>
                    <el-option v-for="(item, index) in allManufacture" :key="index" :label="item.name" :value="item.id"></el-option>
                </el-select>
            </el-form-item> -->
            
            <el-form-item label="充电时间：" class="screen">
                <el-date-picker
                    v-model="timeRange"
                    type="datetimerange"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    @change="dateChange">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="用户手机号：" class="screen">
                <el-input v-model="queryForm.query_columns.phone" placeholder="请输入用户手机号" clearable @change="getTableList('query')"></el-input>
            </el-form-item>
            <el-form-item label="状态：" class="screen">
                <el-select v-model="queryForm.query_columns.status" placeholder="请选择" clearable @change="getTableList('query')">
                    <el-option label="全部" value=""></el-option>
                    <el-option label="充电中" :value="10"></el-option>
                    <el-option label="充电结束" :value="100"></el-option>
                    <el-option label="取消充电" :value="0"></el-option>
                </el-select>
            </el-form-item>
            
            <el-form-item>
                <el-button type="primary" @click="getTableList('query')">查询</el-button>
                <el-button @click="reset">重置</el-button>
            </el-form-item>
        </el-form>

        <div class="tableArea">
            <el-table :data="tableData" class="table-border" style="width: 100%" height="100%">
                <el-table-column type="index" label="序号" align="center"></el-table-column>
                <el-table-column prop="order_id" label="订单号"></el-table-column>
                <el-table-column prop="pipe_group_name" label="桩群名称"></el-table-column>
                <el-table-column prop="pipe_code" label="电桩编号" align="center"></el-table-column>
                <!-- <el-table-column prop="reconciliation_company_name" label="所属厂商"></el-table-column> -->
                <el-table-column prop="p_powers" label="用电量" align="center">
                    <template slot-scope="scope">
                        {{scope.row.p_powers}}kwh
                    </template>
                </el-table-column>
                <el-table-column  label="充电时间">
                    <template slot-scope="scope">
                        {{calcTime(scope.row)}}
                    </template>
                </el-table-column>
                <el-table-column prop="p_minutes" label="充电时长" align="center"></el-table-column>
                <!-- <el-table-column prop="fee" label="电费" align="center"></el-table-column> old -->
                <el-table-column prop="fee_total" label="电费" align="center"></el-table-column>
                <el-table-column prop="fee_service" label="服务费" align="center"></el-table-column>
                <el-table-column prop="combo_name" label="用户类型" align="center"></el-table-column>
                <el-table-column prop="user_mobile" label="用户手机" align="center"></el-table-column>
                <el-table-column prop="end_info" label="结束原因" align="center"></el-table-column>
                <el-table-column prop="status" label="订单状态" align="center"></el-table-column>

                <!-- <el-table-column label="操作" align="center" width="240">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status === 0">
                        <el-button plain size="mini" @click="goExamine(scope.row)">审核</el-button>
                        </div>
                        <div v-else>
                        <el-button plain size="mini" @click="goCheck(scope.row)">查看</el-button>
                        <el-button plain size="mini" @click="goEdit(scope.row)">修改</el-button>
                        <el-button plain size="mini" type="danger" @click="goDel(scope.row)">删除</el-button>
                        </div>
                    </template>
                </el-table-column> -->
            </el-table>
        </div>

        <div class="pageFoot flex">
            <div class="statistical">
                统计：订单数（{{total}}）&nbsp;用电量（{{pageData.powers}}kwh）&nbsp;电费（{{pageData.power_fee}}）&nbsp;服务费（{{pageData.service_fee}}）
            </div>

            <el-pagination
                background
                :current-page="queryForm.page"
                :page-size="queryForm.size"
                :total="total"
                :page-sizes="[20,50,100,200,500,1000]"
                layout="total, prev, pager, next, sizes"
                @size-change="sizeChange"
                @current-change="pageChange">
            </el-pagination>
        </div>
    </div>
</template>
<script>
export default {
    name: 'ChargeOrder',
    data(){
        return {
            queryForm: {
                page: 1,
                size: 20,
                query_columns:{
                    pg_id: '', //桩群id
                    p_id: '', //电桩id
                    id: '', //桩群数据id
                    order_no: '',
                    pile_code: '',
                    company_id: '',
                    phone: '',
                    start_time: '',
                    end_time: '',
                    status: '',
                }
            },
            total: 0,
            tableData: [], //表格数据
            allStation: [], //所有桩群
            allManufacture: [], //所有厂商
            timeRange: [],
            pageData: {
                counts: 0,
                power_fee: 0,
                powers: 0,
                service_fee: 0
            }
        }
    },
    created() {
       this.init() ;
    }, 
    methods: {
        init(){
            this.getTableList();
            this.getAllStationGroup();
            // this.getAllManufacture();
        },
        getTableList(type){
            if(type === 'query'){
                this.queryForm.page = 1;
            }
            this.$http.post(this.common.company + '/api/getRechargeListCompany', this.queryForm).then(res => {
                if(res.code === 200){
                    this.tableData = res.data.list;
                    this.total = res.data.count;
                    if(res.data.list.length != 0){
                        this.pageData = res.data.statistic;
                    }else{
                        this.pageData = {
                            counts: 0,
                            power_fee: 0,
                            powers: 0,
                            service_fee: 0
                        };
                    }
                }else{
                    return this.$message.error(res.msg);
                }
            });
        },
        getAllStationGroup(){
            this.$http.get(this.common.company + '/company/pileGroupAllList').then(res => {
                if(res.code === 200){
                    this.allStation = res.data;
                }else{
                    this.allStaion = [];
                    return this.$message.error(res.msg);
                }
            });
        },
        getAllManufacture(){
            this.$http.get(this.common.company + '/company/companyAllList').then(res => {
                if(res.code === 200){
                    this.allManufacture = res.data;
                }else{
                    this.allManufacture = [];
                    return this.$message.error(res.msg);
                }
            })
        },
        sizeChange(val){
            this.queryForm.size = val;
            this.getTableList();
        },
        pageChange(val){
            this.queryForm.page = val;
            this.getTableList();
        },
        reset(){
            this.queryForm.query_columns = {
                pg_id: '', //桩群id
                p_id: '', //电桩id
                id: '', //桩群数据id
                order_no: '',
                pile_code: '',
                company_id: '',
                phone: '',
                start_time: '',
                end_time: '',
                status: '',
            };
            this.getTableList('query');
        },
        dateChange(val){
            if(val.length != 0){
                this.queryForm.query_columns.start_time = val[0];
                this.queryForm.query_columns.end_time = val[1];
            }else{
                this.queryForm.query_columns.start_time = null;
                this.queryForm.query_columns.end_time = null;
            }
            this.getTableList('query');
        },
        calcTime(data){
            let time = '';
            if(data.end_time == 0){
                time = '';
            }else{
                time = this.formatTime(data.start_time)+' ~ '+this.formatTime(data.end_time);
            }
            return time;
        },
        formatTime(val){
            var time = new Date(val*1000);
            var year = time.getFullYear();
            var month = time.getMonth()+1;
            var day = time.getDate();
            var hour = time.getHours();
            var minute = time.getMinutes();
            var second = time.getSeconds();
            return year+'-'+(month<10?'0'+month:month)+'-'+(day<10?'0'+day:day)+' '+(hour<10?'0'+hour:hour)+':'+(minute<10?'0'+minute:minute)+':'+(second<10?'0'+second:second)
        }
    },
}
</script>
<style lang="less" scoped>
    .order{
        height: 100%;
        display: flex;
        flex-direction: column;

        .tableArea{
            flex: 1;
            max-height: calc(100% - 201px);
        }

        .pageFoot{
            align-items: center;
            justify-content: space-between;
            .statistical{
                font-size: 14px;
            }
        }
    }

    /deep/.el-range-input{
        background-color: transparent;
    }
</style>